import { Option } from '@code/innovance-react-ui-kit';

import { DictionaryLine, ProductOfferBaseData } from 'src/front/api/generated';

const convertProductOfferBaseDataIntoProductOfferComboData = (
  productOfferBaseData: ProductOfferBaseData[]
): ProductOfferComboData[] => {
  return productOfferBaseData.map(
    (productData): ProductOfferComboData => {
      return {
        accountType: productData.accountType,
        brandOwner: productData.brandOwner,
        customerSubType: productData.customerSubType,
        customerType: productData.customerType,
        debitFlag: productData.debitFlag,
        productCardType: productData.cardType,
        resident: productData.residentFlag,
      };
    }
  );
};
export interface ProductOfferComboData {
  customerType: DictionaryLine;
  customerSubType: DictionaryLine;
  debitFlag: DictionaryLine;
  resident: DictionaryLine;
  accountType: DictionaryLine;
  brandOwner: DictionaryLine;
  productCardType: DictionaryLine;
}
export interface ProductOfferFormData {
  customerType: Option | null;
  customerSubType: Option | null;
  debitFlag: Option | null;
  resident: Option | null;
  accountType: Option | null;
  brandOwner: Option | null;
  productCardType: Option | null;
}

export interface ProductOfferComboList {
  customerTypes: Set<Option>;
  customerSubTypes: Set<Option>;
  debitFlags: Set<Option>;
  residents: Set<Option>;
  accountTypes: Set<Option>;
  brandOwners: Set<Option>;
  productCardTypes: Set<Option>;
}
export interface ProductOfferData extends ProductOfferBaseData {
  id: string;
}
export const defaultComboList = {
  customerTypes: new Set<Option>(),
  customerSubTypes: new Set<Option>(),
  debitFlags: new Set<Option>(),
  residents: new Set<Option>(),
  accountTypes: new Set<Option>(),
  brandOwners: new Set<Option>(),
  productCardTypes: new Set<Option>(),
};

export default convertProductOfferBaseDataIntoProductOfferComboData;
